import { createCtx } from './create-context.helper';
import { ProjectTerms } from '@lib/api-interface';

export const [useProjectBranchTermsContext, ProjectBranchTermsContextProvider] = createCtx<ProjectTerms>();
